/**
 * @typedef {object} MatchPart
 * @property {string} text - Een stuk van de oorspronkelijke waarde
 * @property {boolean} hit - Of dit stuk de gezochte term is
 */

/**
 * Knipt een waarde op in stukken, zodat de aanroeper het gezochte deel kan
 * benadrukken zonder zelf met HTML in een string te knoeien.
 *
 * De vergelijking is hoofdletterongevoelig, maar de teruggegeven tekst houdt de
 * oorspronkelijke schrijfwijze — je zoekt op 'woon' en ziet 'Woonstede'.
 *
 * @param {string} [value] - De volledige waarde
 * @param {string} [term] - Waar de gebruiker op zocht
 * @returns {Array<MatchPart>} Leeg bij een lege waarde
 */
const splitOnMatch = (value, term) => {
    const text = String(value || '')
    if (!text) return []

    const needle = String(term || '').trim().toLowerCase()
    if (!needle) return [{ text, hit: false }]

    /** @type {Array<MatchPart>} */
    const parts = []
    const haystack = text.toLowerCase()
    let cursor = 0

    // Met indexOf in plaats van een reguliere expressie: een zoekterm is
    // gebruikersinvoer, en '(' of '*' zou een expressie laten klappen.
    let found = haystack.indexOf(needle, cursor)

    while (found !== -1) {
        if (found > cursor) parts.push({ text: text.slice(cursor, found), hit: false })
        parts.push({ text: text.slice(found, found + needle.length), hit: true })

        cursor = found + needle.length
        found = haystack.indexOf(needle, cursor)
    }

    if (cursor < text.length) parts.push({ text: text.slice(cursor), hit: false })

    return parts
}

export default splitOnMatch
